import { ButtonTheme } from '@/components/Button/theme';
import { tw } from '@/utils/tw';

const Button = tw.theme({
  extend: ButtonTheme,
});
const ModalButton = tw.theme({
  extend: ButtonTheme,
  base: ['mx-auto'],
});

const FollowAuthor = tw.theme({
  slots: {
    base: [],
    modal: ['[&::backdrop]:bg-black/50', 'p-4', 'max-w-[520px]', 'mx-6', 'sm:mx-auto', 'rounded-sm'],
    group: ['flex', 'flex-col', 'gap-3', 'justify-center'],
    headline: ['text-center', 'font-bold', 'text-headline-sm'],
    content: ['text-paragraph-sm', 'mb-3', 'text-center', '[&>p:not(:last-child)]:mb-1'],
    closeButton: ['self-end', 'rounded-sm', 'bg-black', 'p-0.5', 'text-white'],
  },
});

export default Object.assign(FollowAuthor, { Button, ModalButton });
